import { MODAL_SWITCH, MODAL_SAVE_FORM, MODAL_LOADER_BTN, MODAL_CONFIRM_DATA, CONFIRM_MODAL_SWITCH } from '@app/store/constants';

export function getModalSwitch(modal: boolean) {
    return {
        payload: modal,
        type: MODAL_SWITCH
    };
}

export function getModalSaveForm(modal: any[]) {
    return {
        payload: modal,
        type: MODAL_SAVE_FORM
    };
}

export function getConfirmModalSwitch(modal: boolean) {
    return {
        payload: modal,
        type: CONFIRM_MODAL_SWITCH
    };
}

export function getModalConfirmData(modal: any[]) {
    return {
        payload: modal,
        type: MODAL_CONFIRM_DATA
    };
}

export function getLoaderBtn(modal: boolean) {
    return {
        payload: modal,
        type: MODAL_LOADER_BTN
    };
}